<template>
  <div>代理管理</div>
</template>

<script>
export default {

}
</script>

<style>

</style>